<template>
  <div class="top-nav">
    <label class="company-label"><img height="50" width="50" src="../../assets/images/logo-white.png"/><span>研究生学位论文质量送审平台 （客服热线：133 3610 1321/137 7741 0153） </span></label>
    <div class="right-panel">
      <!-- <label v-if="$store.state.user.balances">
        <Icon type="logo-yen" size="14"/>
        {{$store.state.user.balances}}
        <span @click="takeCash">提现</span>
      </label> -->
      <Dropdown>
        <Icon type="md-settings" size="24"/>
        <DropdownMenu slot="list">
          <DropdownItem v-if="$store.state.roleList.length>0" @click.native="switchRole">切换角色</DropdownItem>
          <DropdownItem v-if="userRoleList.includes(identity)" @click.native="$store.state.headerUserMsgFlag = true">用户信息</DropdownItem>
          <DropdownItem @click.native="resetPwd">修改密码</DropdownItem>
          <DropdownItem @click.native="aboutFlag = true">关于</DropdownItem>
          <DropdownItem @click.native="clickLogout">退出</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <Drawer
        title="用户信息"
        v-model="$store.state.headerUserMsgFlag"
        width="720"
        :mask-closable="false"
        class="top-drawer"
        :styles="userStyle"
    >
      <!--<Tabs>
        <TabPane label="个人信息">
        </TabPane>
        <TabPane label="修改头像">
        </TabPane>
      </Tabs>-->
      <Form :model="userFormData" ref="localUserForm" :rules="formRule">
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="姓名" label-position="top" prop="name">
              <Input v-model="userFormData.name" placeholder="请输入姓名" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="手机号" label-position="top" prop="mobile">
              <phone v-model="userFormData.mobile"></phone>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="证件类型" label-position="top" prop="idCardType">
              <Select v-model="userFormData.idCardType" filterable placeholder="请选择证件类型">
                <Option v-for="option in cardTypeList" :value="option.code" :key="option.code">{{option.name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="证件号码" label-position="top" prop="identityCard">
              <Input v-model="userFormData.identityCard" placeholder="请输入证件号码"/>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="送审级别" label-position="top" prop="ssdwLevel" v-if="identityConfig.ssdwLevel.includes(identity)">
              <Input :value="userFormData.ssdwLevel=='1'?'一级':'二级'" readonly></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="单位属性" label-position="top" v-if="identityConfig.schoolType.includes(identity)">
              <Input :value="userFormData.schoolType=='1'?'学校':'其他'" readonly></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="单位名称" label-position="top" v-if="identityConfig.schoolId.includes(identity)">
              <Input v-model="userFormData.schoolName" readonly></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
            <FormItem label="指派级别" label-position="top" v-if="identityConfig.pointLevel.includes(identity)">
              <Input :value="userFormData.pointLevel=='1'?'一级':'二级'" readonly></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="所属学院" label-position="top" prop="department" v-if="identityConfig.department.includes(identity)">
              <Input v-model="userFormData.department" placeholder="请输入所属学院"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="上级联系人" label-position="top" v-if="identityConfig.superiorUserId.includes(identity)">
              <Input :value="userFormData.superiorUserName||userFormData.parentName" readonly></Input>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
            <FormItem label="联系地址" label-position="top" v-if="identityConfig.contactAddress.includes(identity)">
              <Input v-model="userFormData.contactAddress" placeholder="请输入联系地址" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="12">
            <FormItem label="开户省份" label-position="top" v-if="identityConfig.bankProvince.includes(identity)">
              <Select v-model="userFormData.bankProvince" filterable placeholder="请选择开户省份">
                <Option v-for="(option, index) in provinceList" :value="option.id" :key="index">{{option.mc}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="开户银行" label-position="top" v-if="identityConfig.bankId.includes(identity)">
              <Select v-model="userFormData.bankId" filterable placeholder="请选择开户银行">
                <Option v-for="(option, index) in bankList" :value="option.id" :key="index">{{option.mc}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
            <FormItem label="银行卡号" label-position="top" v-if="identityConfig.bankCard.includes(identity)">
              <Input v-model="userFormData.bankCard" placeholder="请输入银行卡号" />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="user-drawer-footer">
        <Button style="margin-right: 8px" @click="$store.state.headerUserMsgFlag = false">取消</Button>
        <Button type="primary" @click="saveCurrent">确认</Button>
      </div>
    </Drawer>
    <Drawer :closable="false" width="300" v-model="aboutFlag">
      <p class="title">关于</p>
      <div class="about-drawer-profile">
        <Row>
          <Col span="24">
            产品: 研究生学位论文质量送审平台
          </Col>
        </Row>
        <Row>
          <Col span="24">
            版本: V2.0
          </Col>
        </Row>
        <Row>
          <Col span="24">
            备案号：浙ICP备19016117号-1
          </Col>
        </Row>
      </div>
      <Divider />
      <p class="title">公司</p>
      <div class="about-drawer-profile">
        <Row>
          <Col span="24">
            公司名称: 杭州匡汇科技有限公司
          </Col>
        </Row>
        <Row>
          <Col span="24">
            公司官网: <a href="http://www.cndatahub.com" target="_blank">http://www.cndatahub.com</a>
          </Col>
        </Row>
      </div>
      <Divider />
      <p class="title">技术支持</p>
      <div class="about-drawer-profile">
        <Row>
          <Col span="24">
            邮箱: libc@cndatahub.com
          </Col>
        </Row>
        <Row>
          <Col span="24">
            电话: 15958157657
          </Col>
        </Row>
      </div>
      <Divider />
      <p class="title">业务支持</p>
      <div class="about-drawer-profile">
        <Row>
          <Col span="24">
            邮箱: hulc@cndatahub.com
          </Col>
        </Row>
        <Row>
          <Col span="24">
            电话:
          </Col>
        </Row>
      </div>
    </Drawer>
    <Modal
        v-model="dialogConfig.show"
        title="修改密码"
        :loading="dialogConfig.loading"
        @on-ok="dialogOK"
    >
      <reset-pwd ref="resetPwd" v-if="dialogConfig.show" query=""></reset-pwd>
    </Modal>
    <Modal
        v-model="dialogConfig2.show"
        title="更改手机号"
        :loading="dialogConfig2.loading"
    >
      <change-number ref="changeNumber" v-if="dialogConfig2.show" query=""></change-number>
    </Modal>
  </div>
</template>

<script>
import ResetPwd from '../dialogs/systemManage/resetPwd'
import Phone from '../../components/defined/phone'
export default {
  components: {ResetPwd, Phone},
  data () {
    return {
      dialogConfig: {
        show: false,
        loading: true
      },
      dialogConfig2: {
        show: false,
        loading: true
      },
      userStyle: {
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        paddingBottom: '53px',
        position: 'static'
      },
      userRoleList: ['2', '3', '4', '6', '8'],
      identity: 0,
      formRule: {
        name: {required: true, message: '姓名不能为空', trigger: 'blur'},
        mobile: {required: true, message: '手机号不能为空', trigger: 'blur'},
        idCardType: {required: true, message: '证件类型不能为空', trigger: 'change'},
        identityCard: {required: true, message: '证件号码不能为空', trigger: 'blur'},
        department: {required: true, message: '所属学院不能为空', trigger: 'blur'}
      },
      defaultUser: null,
      userFormData: {
      },
      cardTypeList: [],
      provinceList: [],
      bankList: [],
      identityConfig: {
        name: ['2', '3', '4', '6', '8'],
        mobile: ['2', '3', '4', '6', '8'],
        idCardType: ['2', '3', '4', '6', '8'],
        identityCard: ['2', '3', '4', '6', '8'],
        pointLevel: ['6', '8'], // 指派级别
        ssdwLevel: ['3', '4'], // 送审级别
        schoolType: ['6', '8'],
        schoolId: ['2', '3', '4', '6', '8'],
        contactAddress: ['3', '4', '6', '8'],
        department: ['4', '8'], // 所属学院
        superiorUserId: ['4', '8'], // 上级联系人
        bankProvince: ['6', '8'],
        bankId: ['6', '8'],
        bankCard: ['6', '8']
      },
      aboutFlag: false
    }
  },
  created () {
    this.identity = this.$store.state.role.identity;
    if (['2', '3', '4', '6', '8'].includes(this.identity)) {
      this.fetchLocalMsg();
      this.fetchCardTypeList();
      this.fetchProList();
      this.fetchBankList();
    }
  },
  methods: {
    fetchLocalMsg () {
      const _self = this
      _self.fetch('/sys/user/getCurrentUser').then(res => {
        _self.userFormData = res.data;
        _self.defaultUser = JSON.parse(JSON.stringify(res.data));
      })
    },
    fetchCardTypeList () {
      let url = '/conf/confIdCardType/all'
      this.fetch(url).then(res => {
        this.cardTypeList = res.data
      })
    },
    // 获取省份列表
    fetchProList () {
      let url = '/conf/confProvince/list'
      this.post(url).then(res => {
        this.provinceList = res.data
      })
    },
    // 获取银行卡列表
    fetchBankList () {
      let url = '/conf/confBank/list'
      this.post(url).then(res => {
        this.bankList = res.data
      })
    },
    saveCurrent () {
      const _self = this;
      _self.$refs['localUserForm'].validate((valid) => {
        if (valid) {
          let param = Object.compare(_self.defaultUser, _self.userFormData);
          if (Object.keys(param).length === 0) {
            _self.$store.state.headerUserMsgFlag = false;
            return;
          }
          param.currentAccountType = _self.defaultUser.currentAccountType;
          param.id = _self.defaultUser.id;
          param.userId = _self.defaultUser.userId;
          param.schoolId = _self.defaultUser.schoolId;
          _self.post('/sys/user/updateCurrentUserInfo', param).then(res => {
            _self.$Message.success(res.msg);
            _self.fetchLocalMsg();
            _self.$store.state.headerUserMsgFlag = false;
          });
        }
      });
    },
    clickLogout () {
      this.post('/sys/logout').then(res => {
        this.$store.commit('sessionMiss');
        this.$router.push({path: '/login'});
      })
    },
    switchRole () {
      this.$store.commit('roleMiss');
      this.$router.push({path: '/login'});
    },
    resetPwd () {
      this.dialogConfig.show = true;
    },
    changeNumber () {
      this.dialogConfig2.show = true;
    },
    takeCash () {
      this.$Message.info('跳转到提现页面');
    },
    dialogOK () {
      const _self = this;
      _self.$refs['resetPwd'].dialogComfirm().then(val => {
        // 确定成功后让用户重新登录
        _self.$Modal.success({
          title: '密码修改成功',
          content: '个人密码修改成功，请重新登录。',
          onOk: () => {
            _self.clickLogout();
          }
        });
      }).catch(() => {
        _self.dialogConfig.loading = false;
        _self.$nextTick(function () {
          _self.dialogConfig.loading = true;
        })
      });
    }
  }
}
</script>

<style lang="less" scoped>
.changephone{
  margin-top: 10px;
  margin-left: -25px;
}
.top-nav {
  .company-label {
    color: @normal-color;
    font-size: @font-size-large;
    img {
      display: inline-block;
      float: left;
      margin: 5px 10px 5px 0;
    }
    span {
      display: inline-block;
    }
  }
  .right-panel {
    color: @normal-color;
    float: right;
    margin: 17px 20px;
    height: 30px;
    line-height: 30px;
    span {
      cursor: pointer;
    }
  }
}
.title {
  font-size: 16px;
  color: rgba(0,0,0,0.85);
  line-height: 24px;
  display: block;
  margin-bottom: 16px;
}
  .about-drawer-profile{
    font-size: 14px;
  }
  .about-drawer-profile .ivu-col{
    margin-bottom: 12px;
  }
  .user-drawer-footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }
</style>
<style lang="less">
  .top-drawer {
    .kh-input[readonly=readonly] {
      box-shadow: 0 0 0 2px rgba(@border-color-base, .3);
      border: 0 none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/home/topNav.vue